export function buildFilterLabel(filters, keys) {
  const split = (v) => (v ? String(v).split(',').map((s) => s.trim()).filter(Boolean) : []);

  const fullParts = [];
  const shortParts = [];

  (keys || []).forEach((k) => {
    const arr = split(filters?.[k]);
    if (!arr.length) return;
    fullParts.push(arr.join(', '));
    shortParts.push(arr.length <= 2 ? arr.join(', ') : `${arr[0]}, +${arr.length - 1} more`);
  });

  return {
    full: fullParts.join(', '),
    short: shortParts.join(', '),
  };
}

